<template>
  <div>
    
  </div>
</template>

<script>
export default {
  name: 'AfrimedFrontRegister',

  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>

<style lang="scss" scoped>

</style>